export const userOsIdentifier = () => {
  let OsPlatform: string;
  if (navigator?.platform) {
    OsPlatform = navigator?.platform?.toLowerCase();
  } else if (navigator?.userAgent) {
    OsPlatform = navigator?.userAgent?.toLowerCase();
  } else {
    return 'windows';
  }
  if (OsPlatform?.includes('mac')) {
    return 'mac';
  }
  return 'windows';
};

export const getAiSearchShortcut = (
  detectedDeviceForAiSearch: 'mac' | 'windows' | '',
) => {
  if (detectedDeviceForAiSearch === 'mac') {
    return '⌘ K';
  }
  return 'Ctrl+K';
};

export const placeholderSuggestions = [
  'Find me people from investment banking in the US.',
  'Find California CEOs with fewer than 50 staff.',
  'Find HR professionals working in startups under 200 employees.',
  'Find SEO specialists with 10+ years of experience.',
];

export const aiPeopleSuggestions = [
  'Find CTOs and VPs at B2B companies with 50-200 employees in the US.',
  'Find marketing managers at companies with over 500 employees in New York.',
];

export const aiCompanySuggestions = [
  'Find companies similar to HubSpot with fewer than 200 employees.',
  'Find private companies in California founded after 2020 with recent funding.',
];


export const getUserRecentSearches = (userEmail?: string): any[] => {
  if (!userEmail) return [];

  try {
    const recentSearches = JSON.parse(
      localStorage?.getItem('aiV2SearchHistory') || '[]',
    );
    return recentSearches?.[userEmail] || [];
  } catch (error) {
    console.error('Failed to parse aiV2SearchHistory from localStorage', error);
    return [];
  }
};
